import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { errorCatch, GET, JSXMap, useAuth } from 'fennec-ui';
const { Link } = Typography;


export function Agreement(props) {
    const { nastroikaEkvairingaID } = props;
    const auth = useAuth();

    const [documentiOrganizatora, setDocumentiOrganizatora] = useState();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        GET(auth, `/papi/documenti-organizatora/${nastroikaEkvairingaID}`,
            ({ data }) => {
                setDocumentiOrganizatora(data);
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, []);

    return (<div style={{ fontSize: "12px" }}>
        <div>Вам необходимо поставить «галочку», подтвердив тем самым, что Вы:</div>
        <ul>
            <li>ознакомлены с <Link target="_blank" rel="noopener noreferrer" href="/fed/about/ticket-purchase">алгоритмом покупки билетов</Link>,</li>
            {(!!documentiOrganizatora?.length) && <li>ознакомлены, принимаете условия и согласны со следующими документами: 
                {JSXMap(documentiOrganizatora, (e, idx) => {
                    if (!e?.key || !e?.description) {
                        return <></>
                    }

                    return (<span key={idx} >{(!!idx)?", ":" "} <Link target="_blank" rel="noopener noreferrer" href={`/fed/about/document/${e?.key}/${nastroikaEkvairingaID}`}>{e?.description?.toLowerCase()}</Link></span>)
                })}
            </li>}
            {/* <li>принимаете условия <Link target="_blank" rel="noopener noreferrer" href={`/fed/about/document/user-agreement/${nastroikaEkvairingaID}`}>Пользовательского соглашения</Link>,</li>
            <li>ознакомлены и согласны со <Link target="_blank" rel="noopener noreferrer" href={`/fed/about/document/payment-methods/${nastroikaEkvairingaID}`}>способами оплаты</Link>,
                <Link target="_blank" rel="noopener noreferrer" href={`/fed/about/document/conditions-refund/${nastroikaEkvairingaID}`}> условиями возврата</Link><Link target="_blank" rel="noopener noreferrer" href="/fed/about/privacy-policy"> и Политикой конфиденциальности</Link>.</li> */}
        </ul>
    </div>);
}
export default React.memo(Agreement)
// Agreement.whyDidYouRender = true
